import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

/**
 * Controls the open/closed state of the Movimentação do Caixa screen (US #61510) — the copy of
 * `CashClosingModalService`, for the same reasons.
 *
 * An OVERLAY — not a route (D-17): no SPA route, no deep link, no history entry. Its ONE entry point is the
 * Movimentação button of the Controle de Caixa page header (D-106 — there is no menu leaf), which opens it through
 * this singleton; `LayoutComponent` mounts the modal only while `open$` is `true`, stacked over the page.
 *
 * Close-on-nav: the layout host is re-created on every navigation, and an overlay left open would be mounted a second
 * time by the new layout.
 */
@Injectable({
  providedIn: 'root'
})
export class CashMovementReportModalService {
  private readonly openState$ = new BehaviorSubject<boolean>(false);

  /** Emits the current open state; replays the latest value to new subscribers. */
  readonly open$: Observable<boolean> = this.openState$.asObservable();

  constructor(private readonly router: Router) {
    // Root singleton: the subscription lives for the app lifetime, so there is nothing to unsubscribe.
    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe(() => this.close());
  }

  /** Opens the overlay (mounts the modal via the layout host). */
  open(): void {
    this.openState$.next(true);
  }

  /** Closes the overlay (unmounts the modal). No navigation. */
  close(): void {
    this.openState$.next(false);
  }
}
